module.exports = "/lucky-balls/img/bonus_yellow/check_infoBar/check_004.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bonus_yellow/check_infoBar/check_004.png
// module id = 949
// module chunks = 0